import { SolutionOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import FormFields from '../../../../themes/admin/Fields/FormFields';
import { type SelectFieldProps } from '../../SelectField';
import {
    type DealershipDepositAmountDrawerProps,
    useDealershipDepositAmountDrawer,
} from './DealershipDepositAmountDrawer';

export type DealershipDepositAmountFieldProps = Pick<SelectFieldProps, 'options' | 'name' | 'disabled' | 'label'> &
    Pick<DealershipDepositAmountDrawerProps, 'dealers'>;

const DealershipMarketField = ({ name, dealers, disabled, options, ...props }: DealershipDepositAmountFieldProps) => {
    const drawer = useDealershipDepositAmountDrawer();

    // hide button completely when disable
    const button = disabled ? null : (
        <Button
            icon={<SolutionOutlined style={{ color: 'var(--ant-primary-color)' }} />}
            onClick={drawer.open}
            size="small"
            type="text"
        />
    );

    return (
        <>
            <FormFields.InputNumberField name={`${name}.defaultValue`} {...props} addonAfter={button} />
            {drawer.render({ name, title: props.label, dealers, options })}
        </>
    );
};

export default DealershipMarketField;
